import { z } from 'zod';

// https://docs.slace.com/docs/stoplight-docs-core/355e31abccf5f-conversation-message
export const schemaSlaceConversationMessage = z.object({
    activity_id: z.string().optional(),
    // this should usually be schemaSlaceCommunicationChannel but that would reference this schema recursively
    author: z.unknown(),
    // this should usually be schemaSlaceConversation but that would reference this schema recursively
    conversation: z.unknown(),
    conversation_id: z.string(),
    data: z.object({}).optional(),
    direction: z.enum(['in', 'out']),
    gateway_id: z.string(),
    id: z.string(),
    info: z.record(z.unknown()).optional(),
    labels: z.array(z.string()).optional(),
    // this should usually be schemaSlaceConversationMessage but that would reference this schema recursively
    reply_to: z.unknown().optional(),
    source: z.string(),
    status: z.enum(['queued', 'retrying', 'error', 'error_provider', 'sent', 'delivered', 'read', 'played', 'deleted']),
    text: z.string().optional(),
    timestamp: z.string(),
    type: z.enum([
        'text',
        'image',
        'video',
        'audio',
        'document',
        'file',
        'sticker',
        'location',
        'contact',
        'template',
        'buttons',
        'list',
        'info',
        'order_details',
        'order_status',
        'story',
        'request_location',
        'request_phone_number',
        'remove_keyboard',
    ]),
    user_deleted_at: z.string().optional(),
    user_edited_at: z.string().optional(),
});

export type SchemaSlaceConversationMessage = z.infer<typeof schemaSlaceConversationMessage>;
